<div class="header">
    <app-top-bar></app-top-bar>
    <app-header-navigation></app-header-navigation>
    <app-header-title [title]="title" [subtitle]="subtitle"></app-header-title>
</div>
<app-header-breadcrumbs></app-header-breadcrumbs>